import React, { HTMLAttributes, ReactNode } from 'react';
import { VariantProps } from 'class-variance-authority';
import cn from '@/utils/cn';
import { ExitIcon } from '../Icons';
import { capsuleVariants } from './capsuleVariants';

interface CapsuleProps
  extends HTMLAttributes<HTMLDivElement>,
    VariantProps<typeof capsuleVariants> {
  closeIconClassName?: string;
  customLabel?: string | ReactNode;
  onClose?: () => void;
}

const Capsule: React.FC<CapsuleProps> = ({
  variant,
  className,
  customLabel,
  style,
  closeIconClassName,
  onClose,
  ...props
}) => {
  return (
    <div className={cn(capsuleVariants({ variant, className }))} {...props} style={style}>
      <span data-testid="CapsuleLabel" className="text-center">
        {customLabel ? customLabel : variant}
      </span>
      {onClose ? (
        <a data-testid="CapsuleCloseButton" onClick={onClose} className={closeIconClassName}>
          <ExitIcon className="w-3 h-3 cursor-pointer" />
        </a>
      ) : null}
    </div>
  );
};

export default Capsule;
